<template>
    <v-menu offset-y right>
        <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
                <v-icon
                    color="secondary"
                    v-text="icons.mdiFormatListCheckbox"
                ></v-icon>
            </v-btn>
        </template>

        <v-list dense>
            <template>
                <!-- <v-list-item
                    href="#"
                    v-if="withPDF"
                    @click="$emit('exportPDF')"
                >
                    <v-list-item-icon class="mr-3">
                        <v-icon :color="exportLinks[1].color" v-text="exportLinks[1].icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-title
                        v-text="exportLinks[1].text[lang]"
                    ></v-list-item-title>
                </v-list-item> -->

                <!-- <v-list-item
                    href="#"
                    @click="$emit('exportExcel')"
                >
                    <v-list-item-icon class="mr-3">
                        <v-icon :color="exportLinks[0].color" v-text="exportLinks[0].icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-title
                        v-text="exportLinks[0].text[lang]"
                    ></v-list-item-title>
                </v-list-item> -->

                <v-list-item href="#" @click="csvButtonClicked()">
                    <v-list-item-icon class="mr-3">
                        <v-icon
                            :color="exportLinks[2].color"
                            v-text="exportLinks[2].icon"
                        ></v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        <span v-if="buttonStatusCSV == 1">
                            {{ exportBtnTitle[lang] }}
                        </span>
                        <v-progress-circular
                            v-if="buttonStatusCSV == 2"
                            :size="20"
                            color="primary"
                            indeterminate
                        ></v-progress-circular>
                        <div v-if="buttonStatusCSV == 3" class="d-flex">
                            <div>
                                <a :href="urlCSV" target="_blank">
                                    {{ downloadBtnTitle[lang] }}
                                </a>
                                <div>
                                    {{ lastExport[lang] + createdAt }}
                                </div>
                            </div>
                            <v-icon
                                v-text="icons.mdiDelete"
                                color="red"
                                @click="$emit('deleteCSV')"
                            ></v-icon>
                        </div>
                    </v-list-item-title>
                </v-list-item>
            </template>
        </v-list>
    </v-menu>
</template>

<script>
import {
    mdiFormatListCheckbox,
    mdiMicrosoftExcel,
    mdiFilePdf,
    mdiFileDelimitedOutline,
    mdiDelete,
} from "@mdi/js";
import moment from "moment";

export default {
    name: "ExportLinks",

    props: {
        withPDF: Boolean,
        buttonStatusCSV: {
            default: 1,
            value: Number,
        },
        urlCSV: {
            default: null,
            value: String,
        },
        createdAt: {
            default: "",
            value: String,
        },
        downloadBtnTitle: {
            default: () => {
                return {
                    el: "Λήψη αρχείου CSV",
                    en: "Download CSV file",
                    it: "Scarica il file CSV",
                };
            },
            value: Object,
        },
        exportBtnTitle: {
            default: () => {
                return {
                    el: "Λήψη αρχείου CSV",
                    en: "Export to CSV file",
                    it: "Esportazione in file CSV",
                };
            },
            value: Object,
        },
    },

    data: () => ({
        icons: { mdiFormatListCheckbox, mdiDelete },
        exportLinks: [
            {
                icon: mdiMicrosoftExcel,
                text: {
                    el: "Λήψη αρχείου Excel",
                    en: "Export to Excel",
                    it: "Esporta in Excel",
                },
                color: "green darken-3",
            },
            {
                icon: mdiFilePdf,
                text: { el: "", en: "Export to PDF", it: "" },
                color: "red darken-4",
            },
            {
                icon: mdiFileDelimitedOutline,
                text: {
                    el: "Λήψη αρχείου CSV",
                    en: "Export to CSV",
                    it: "Esporta in CSV",
                },
                color: "blue darken-3",
            },
        ],
        lastExport: {
            el: "Τελευταία Έκδοση: ",
            en: "Last Export: ",
            it: "Ultima Esportazion: ",
        },
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },
    },

    methods: {
        csvButtonClicked() {
            if (this.buttonStatusCSV == 1) {
                this.$emit("exportCSV");
            }
        },
    },
};
</script>
